var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "star-rating" },
    _vm._l(_vm.maxStars, function(i) {
      return _c(
        "div",
        {
          key: i,
          class: [
            "star",
            i <= (_vm.isHovered ? _vm.hoverValue : _vm.rating) ? "filled" : ""
          ],
          on: {
            click: function($event) {
              return _vm.setRating(i)
            },
            mouseover: function($event) {
              return _vm.hoverRating(i)
            },
            mouseleave: _vm.resetHover
          }
        },
        [_vm._v(" ★ ")]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }